// src/components/AboutSection.jsx
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.25 },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

export default function AboutSection() {
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setOffsetY(window.scrollY * 0.2);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section className="relative bg-white py-24 overflow-hidden">
      {/* Background overlay image with parallax */}
      <motion.div
        className="absolute inset-0"
        style={{ transform: `translateY(${offsetY}px)` }}
      >
        <div
          className="absolute inset-0 bg-cover bg-center opacity-10 pointer-events-none"
          style={{ backgroundImage: "url('/luxeheights2.jpg')" }}
        />
      </motion.div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-16 items-center">
        {/* Left: Text content */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.4 }}
          className="space-y-6"
        >
          <motion.h2
            variants={item}
            className="text-3xl md:text-4xl font-bold text-gray-900"
          >
            About Aspen Plush Homes
          </motion.h2>

          <motion.p
            variants={item}
            className="text-gray-600 leading-relaxed max-w-lg"
          >
            At Aspen Plush Homes, we design and deliver modern, elegant living
            spaces that blend luxury with comfort. Every project reflects our
            passion for quality craftsmanship and innovative architecture.
          </motion.p>

          <motion.div variants={item}>
            <Link
              to="/about"
              className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg shadow hover:bg-blue-700 transition"
            >
              Learn More
            </Link>
          </motion.div>
        </motion.div>

        {/* Right: Image */}
        <motion.div
          initial={{ opacity: 0, scale: 1.05 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="relative"
        >
          <img
            src="/luxeheights2.jpg"
            alt="About Aspen Plush Homes"
            className="rounded-2xl shadow-lg"
          />
        </motion.div>
      </div>
    </section>
  );
}
